import { IGlobalMessagingState } from 'types'

interface IStore {
  globalMessaging: IGlobalMessagingState
}

export const globalMessagingSelector = ({ globalMessaging }: IStore): IGlobalMessagingState =>
  globalMessaging
